import { APIGet, APIUrl, AdminType } from "api/protocols";
import { IConfiguration } from "api/rpc/clientAdmin/client/report";
import { CancelToken } from "axios";

//GET Report
export interface IReport {
  id: number;
  title: string;
  code: string;
  configurations?: Array<IConfiguration>;
  client_id: string | null;
  category: string;
  sub_category: string | null;
  data: [];
  queue_after_days: number;
  created_at: string | null;
  updated_at: string | null;
  deleted_at: string | null;
}

interface IGetReport {
  id?: number;
  code?: string;
  search?: string;
  configurations?: Array<IConfiguration>;
  parent_id?: number;
}

//Retrieve CSV Download URL
export async function GetCSVDownload(params: any, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/facility/report/run"), params, useGlobalLoader, token);
}

//Retrive Report
export async function GetReport(params: IGetReport, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<IReport[]>(APIUrl(AdminType.FacilityAdmin, "/facility/report"), params, useGlobalLoader, token);
}

// Retrive Data for a Report
export async function GetReportRun(params: any, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/facility/report/run"), params, useGlobalLoader, token);
}

export async function GetReportStatus(params: any, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/facility/report/status"), params, useGlobalLoader, token);
}
